import { render, staticRenderFns } from "./AllPrivilegeTable.vue?vue&type=template&id=62e4b56c&scoped=true&"
import script from "./AllPrivilegeTable.vue?vue&type=script&lang=js&"
export * from "./AllPrivilegeTable.vue?vue&type=script&lang=js&"
import style0 from "./AllPrivilegeTable.vue?vue&type=style&index=0&id=62e4b56c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4b56c",
  null
  
)

export default component.exports